	<link rel="stylesheet" href="/assets/style/font-awesome.min.css">
	<link rel="stylesheet" href="/assets/style/owl.carousel.min.css">
	<section class="index-banner pad">
			<div class="container-fluid">
				<div class="container">
					<div class="row align-items-center justify-content-center">
						<div class="col-lg-6">
							<h2 class="title-banner mbtm20"> Interlace Laboratory<br>
								Management System</h2>
							<a class="btn btn-dark btn-md" style="margin-right:5px;" type="text" routerLink="/contact">BOOK FOR DEMO</a>
							<!-- <div class="button-blue"><a href="#">
							<strong>BOOK FOR DEMO</strong>
						</a> -->
						</div>
						<div class="col-lg-6">

						</div>
					</div>
				</div>
			</div>
			<a class="btn btn-primary btn-md BROCHURE-btn" type="text" href="assets/ILMS_Brochure.pdf" target="_blank">DOWNLOAD BROCHURE</a>
	</section>

    <style>
        .contain {
            position: relative;
            /* //  width: 50%; */
        }

        .image {
            display: block;
            width: 100%;
            height: auto;
        }

        .overlay {
            position: absolute;
            bottom: 100%;
            /* //left: 0;
            //right: 0; */
            background-color: #0685d4;
            overflow: hidden;
            width: 92.5%;
            height: 0;
            transition: .5s ease;
            border-radius: 4px;
            cursor: pointer;

        }

        .contain:hover .overlay {
            bottom: 0;
            height: 100%;
        }

        .text {
            color: white;
            font-size: 20px;
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            text-align: center;
        }

        video#bgVideo {
            /* position: absolute; // Play the video in full screen mode */
            top: 0px;
            left: 0px;
            min-width: 100%;
            min-height: 100%;
            /* z-index: -1; // Put the video behind all other elements */
        }
    </style>


    <section class="">
        <div class="container">
            <div class="row mbtm1em">
                <div class="col-md-12">
                    <h2 class="title2 text-center pbtm2em ptop2em">
                        <strong>Service Offerings</strong>
                    </h2>
                </div>
                <div class="col-md-4 col-sm-6 text-center contain margin-bottom2em"> <img
                        src="assets/images/dataSecurityBackup.jpg" width="100%" alt="Techincal Support"
                        class=" border-radius6">
                    <!-- <div class="overlay">
                        <h3 class="title2 whitefont marginem">Technical Support</h3>
                        <div class="padding-left1em padding-right1em whitefont">Update Soon... </div>
                    </div> -->
                </div>
                <div class="col-md-4 col-sm-6 text-center contain margin-bottom2em"> <img
                        src="assets/images/offered_services_deviceintegration.jpg" width="100%" alt="Automatic Backups"
                        class=" border-radius6">
                    <!-- <div class="overlay">
                        <h3 class="title2 whitefont marginem">Automatic Backups</h3>
                        <div class="padding-left1em padding-right1em whitefont">Update Soon... </div>
                    </div> -->
                </div>
                <div class="col-md-4 col-sm-6 text-center contain margin-bottom2em"> <img
                        src="assets/images/support&trainee.jpg" width="100%" alt="Legacy Data Migration"
                        class=" border-radius6">
                    <!-- <div class="overlay">
                        <h3 class="title2 whitefont marginem">Legacy Data Migration</h3>
                        <div class="padding-left1em padding-right1em whitefont">Update Soon...</div>
                    </div> -->
                </div>
            </div>
        </div>
    </section>

    <section class="trustes-customers pricing-area">
        <div class="container">
            <div class="row text-center justify-content-center">
				<div class="col-lg-12">
					<h4 class="mb-5 font-weight-bold ">ILMS Package<small></small></h4>
				</div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>STANDARD Version</h3>
                        </div>
                          <ul class="pricing-features ILMS_list">
                            <li>
                                Product with defined 3 user license
                            </li>
                            <li>
                                Online Support for a Year
                            </li>
                            <li>
                                99.9% application availability
                            </li>
                            <li>
                                10,000 WhatsApp or SMS, Email based Reports & &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Notifications
                            </li>
							<li>
                               Includes storage for reports
                            </li>
							<!-- <li> -->
                               <!-- 8x5 online support -->
                            <!-- </li> -->
							<li>
                               Data protection and data backup
                            </li>
							<li>
								Latest software updates
							</li>
                        </ul>
                    </div>
                </div>
	            <div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>LITE Version</h3>
                        </div>
                          <ul class="pricing-features ILMS_list">
                            <li>
                                Product with defined 2 user license.
                            </li>
                            <li>
                                Online Support for a Year
                            </li>
                            <li>
                                99.9% application availability
                            </li>
                            <li>
                                3,000 WhatsApp or SMS, Email based Reports & &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Notifications
                            </li>
							<li>
                               Includes storage for reports
                            </li>
							<li>
                               Data protection and data backup
                            </li>
							<li>
								Latest software updates for 1 year
							</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>Additional add-ons</h3>
                        </div>
                        <ul class="pricing-features ILMS_list">
                            <li> Additional license - 3 users</li>
                            <li> Storage for additional 10,000 reports</li>
                            <li> Unidirectional Device integration</li>
                            <li> Bi-directional device integration</li>
                            <li> One time Configuration</li>
                            <li> Additional Online Training <br> &nbsp;</li>
                        </ul>
                    </div> 
                </div>
                <div class="col-lg-12">
                    <a class="btn btn-info btn-md my-4" type="text" routerLink="/tenant-registration/1">BUY NOW</a>&nbsp;&nbsp;
					<a class="btn btn-danger btn-md my-4" type="text" routerLink="/contact">FREE TRIAL</a>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="bg-grey2"> -->
        <!-- <div class="container pbtm2em "> -->
            <!-- <div class="row"> -->
                <!-- <div class="col-md-12"> -->
                    <!-- <h2 class="text-center ptopemem pbtmemem"> -->
                        <!-- <span>Our Clients</span> -->
                    <!-- </h2> -->
                <!-- </div> -->
                <!-- <div class="col-sm-12 text-center"> -->
                    <!-- <img src="/assets/images/affigenix.png" alt="" max-width="100%" class="center"> -->
                <!-- </div> -->

            <!-- </div> -->
        <!-- </div> -->
    <!-- </section> -->
	<section class="pbtm2em ptop2em" style="position:relative;">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="col-md-8 col-md-offset-2">
                    <h2 class="title2 text-center pbtm2em ptop2em">
                        <strong>Testimonials</strong>
                    </h2>
                    <div class="testimonial-bg">
                        <div id="testimonial-slider" class="owl-carousel">
                            <div class="testimonial">
                                <p class="description">
                                    The Quality & price of the product is excellent. We feel valued by them and they closely work with us in finding our customer needs. We are happy with the performance and it greatly reduced our processing time. The team behind ILMS has always been helpful and they were there for us whenever we needed them for the support. We would like to suggest ILMS and ERP of Interlace India for all those who wanted to work with an excellent support team.
                                </p>
                                <div class="pic">
                                    <img src="assets/images/affigenix.png" alt="">
                                </div>
                                <!-- <h3 class="title">Williamson,</h3> -->
                                <!-- <span class="post">Web Developer</span> -->
                            </div>

                            <!-- <div class="testimonial"> -->
                                <!-- <p class="description"> -->
                                    <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec at augue sed elit -->
                                    <!-- eleifend tempus. Etiam malesuada vulputate justo quis bibendum. Nam maximus -->
                                    <!-- ultricies -->
                                    <!-- rhoncus. Ut non felis vel enim dapibus. -->
                                <!-- </p> -->
                                <!-- <div class="pic"> -->
                                    <!-- <img src="assets/images/user-1.png" alt=""> -->
                                <!-- </div> -->
                                <!-- <h3 class="title">kristiana,</h3> -->
                                <!-- <span class="post">Web Designer</span> -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
 
